<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import '@/plugins/highcharts.js'
import { useCoreStore } from '../../stores/core'

export default {
  name: 'TravelsModesDistancesBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    values: function () {
      let values = []
      let distances = this.ghgi.emissions.travels.status.distances
      for (let position of Object.keys(distances)) {
        let allTransportations = {}
        let i = 0
        for (let transportations of Travel.transportations) {
          allTransportations[transportations] =
            '<nobr>' +
            this.$options.filters.splitNumber(distances[position][i]) +
            '</nobr>'
          i += 1
        }
        allTransportations['position'] =
          '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allTransportations)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let transportation of Travel.transportations) {
        columns.push({
          field: transportation,
          label: this.$t(transportation),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let series = []
      for (let status of this.coreStore.travelPositionLabels) {
        series.push({
          name: this.$t(status),
          data: this.ghgi.emissions.travels.status.distances[status].map(
            (value) => Math.round(value)
          )
        })
      }
      return series
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: Travel.transportations.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('distances.km')
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: ' ' + this.$t('km')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
